var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.size=='large')?_c('v-btn',{attrs:{"color":_vm.color,"large":"","elevation":"15"}}):_c('v-btn',{attrs:{"color":_vm.color,"small":"","outlined":""}}),_c('div',[_c('v-chip',{attrs:{"x-small":""}},[_c('strong',[_vm._v(_vm._s(_vm.label))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }